import { ReactNode, useEffect } from 'react'
import { Card } from '@/common/ui/Card'
import { Link } from 'react-router-dom'
import Logo from '@/common/ui/Navbar/logo.svg'
import { ToastProvider, ToastViewport } from '@/common/ui/Toast/ToastProvider'
import { SelectPortalRoot } from '@/common/ui/Form/Select'

interface AuthLayoutProps {
    children: ReactNode
}

const AuthLayout = ({ children }: AuthLayoutProps) => {
    useEffect(() => {
        // Добавляем мета-тег noindex для технических страниц auth
        const metaRobots = document.createElement('meta')
        metaRobots.name = 'robots'
        metaRobots.content = 'noindex, nofollow'
        document.head.appendChild(metaRobots)

        return () => {
            // Удаляем мета-тег при размонтировании компонента
            document.head.removeChild(metaRobots)
        }
    }, [])

    return (
        <ToastProvider>
            <div className='min-h-screen bg-base-100 px-2 relative'>
                <div className='flex items-center justify-center min-h-screen'>
                    <div className='flex flex-col items-center justify-center gap-[3.125rem]'>
                        <Link to='/app/'>
                            <Logo className='h-[30px] w-[165px]' />
                        </Link>
                        <Card>
                            <div className='w-[23.125rem]'>{children}</div>
                        </Card>
                    </div>
                </div>
            </div>
            <SelectPortalRoot />
            <ToastViewport />
        </ToastProvider>
    )
}

export default AuthLayout
